// Copyright 2019 Sorama B.V.

import { Currency } from "./Currency";
import { Length } from "./Length";
import { Mass } from "./Mass";
import { MassFlow } from "./MassFlow";
import { Pressure } from "./Pressure";
import { Unit } from "./Unit";
import { VolumeCost } from "./Volume";
import { FlowEffort, VolumeFlow } from "./VolumeFlow";

export class UnitSystem {
    public static Imperial: UnitSystem = {
        name: "Imperial",
        distance: Length.feet,
        flow: VolumeFlow.cubicFeetPerMinute,
        pressure: Pressure.psi,
        currency: Currency.USD,
        flowEffort: FlowEffort.kwPer100Cfm,
        weight: Mass.kiloGram,
        massFlow: MassFlow.gramsPerHour,
        volumeCost: VolumeCost.usdPerCubicFoot,
    };

    public static Metric: UnitSystem = {
        name: "Metric",
        distance: Length.meter,
        flow: VolumeFlow.litersPerMinute,
        pressure: Pressure.bar,
        currency: Currency.EUR,
        flowEffort: FlowEffort.kwPer100LiterMinute,
        weight: Mass.kiloGram,
        massFlow: MassFlow.gramsPerHour,
        volumeCost: VolumeCost.euroPerLiter,
    };

    public name: string;
    public distance: Unit = Length.meter;
    public pressure: Unit = Pressure.bar;
    public flow: Unit = VolumeFlow.litersPerMinute;
    public massFlow: Unit = MassFlow.gramsPerHour;
    public currency: Unit = Currency.EUR;
    public flowEffort: Unit = FlowEffort.kwPer100LiterMinute;
    public weight: Unit = Mass.kiloGram;
    // Volume cost is defined for a given volume size (because sometimes we want to show 'per 1000L' instead of 'per m³')
    public volumeCost: Unit = VolumeCost.euroPerLiter;
    public static All: UnitSystem[] = [UnitSystem.Metric, UnitSystem.Imperial];
}
